(() => {
  if (window.LeslisSearchEvents) return;
  let config;
  try { config = JSON.parse(document.getElementById('LeslisSearchConfig')?.textContent || 'null'); } catch { return; }
  if (!config || config.version !== 1) return;
  const viewed = new WeakMap();
  const pending = new WeakMap();
  let sent = 0;

  function consentAllowed() {
    try {
      return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true && window.Cookiebot?.consent?.statistics === true;
    } catch { return false; }
  }

  function isPreview() {
    return config.designMode !== false || window.Shopify?.designMode === true || window.Shopify?.theme?.role !== 'main' ||
      new URL(location.href).searchParams.has('preview_theme_id');
  }

  function endpoint() {
    try {
      if (!config.endpoint) return null;
      const url = new URL(config.endpoint, location.origin);
      return url.origin === location.origin && url.pathname.startsWith('/apps/') ? url.href : null;
    } catch { return null; }
  }

  function cleanQuery(value) {
    const valueString = String(value || '').normalize('NFKC').replace(/[\u0000-\u001f\u007f]/g, '').trim().replace(/\s+/g, ' ').slice(0, 120);
    return !valueString || /@|https?:\/\/|www\.|\d[\d\s()+.-]{6,}\d/i.test(valueString) ? null : valueString;
  }

  function record(kind, data) {
    const destination = endpoint();
    if (!destination || isPreview() || !consentAllowed()) return false;
    const query = cleanQuery(data.query);
    if (!query || typeof crypto.randomUUID !== 'function') return false;
    const position = Number(data.position);
    const count = Number(data.resultCount);
    const event = {
      version: 1, eventId: crypto.randomUUID(), kind, query, source: data.source,
      resultCount: Number.isFinite(count) ? Math.max(0, Math.min(100000, count)) : null,
      productId: data.productId ? String(data.productId).replace(/\D/g, '').slice(0, 25) : null,
      productTitle: data.productTitle ? String(data.productTitle).slice(0, 200) : null,
      position: data.position && Number.isFinite(position) ? Math.max(1, Math.min(10000, position)) : null
    };
    const body = JSON.stringify(event);
    let queued = false;
    try { queued = navigator.sendBeacon?.(destination, new Blob([body], { type: 'text/plain;charset=UTF-8' })) === true; } catch {}
    if (!queued) {
      try {
        fetch(destination, { method: 'POST', body, headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, keepalive: true, credentials: 'same-origin' }).catch(() => {});
      } catch { return false; }
    }
    sent += 1;
    return true;
  }

  function predictiveVisible(element) {
    const owner = element.closest('predictive-search');
    if (!owner || !owner.hasAttribute('open') || owner.hasAttribute('loading')) return false;
    const details = owner.closest('details');
    if (details && !details.open) return false;
    const input = owner.querySelector('input[name="q"]');
    return String(input?.value || '').trim().replace(/\s+/g, ' ') === String(element.dataset.leslisQuery || '').trim().replace(/\s+/g, ' ');
  }

  function impression(element, source) {
    if (!element?.isConnected || document.visibilityState !== 'visible' || (source === 'predictive' && !predictiveVisible(element))) return;
    const key = [element.dataset.leslisQuery, element.dataset.leslisResultCount, element.dataset.leslisPage || 1].join('|');
    if (viewed.get(element) === key) return;
    if (record(source === 'predictive' ? 'suggestions_viewed' : 'results_viewed', {
      query: element.dataset.leslisQuery, source, resultCount: element.dataset.leslisResultCount
    })) viewed.set(element, key);
  }

  function schedule(owner) {
    if (!owner) return;
    clearTimeout(pending.get(owner));
    pending.set(owner, setTimeout(() => impression(owner.querySelector('[data-leslis-predictive-results]'), 'predictive'), 800));
  }

  document.addEventListener('leslis:search-rendered', (event) => schedule(event.target.closest('predictive-search')));
  document.addEventListener('input', (event) => {
    const owner = event.target.closest('predictive-search');
    if (owner) clearTimeout(pending.get(owner));
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    const card = link?.closest('[data-leslis-product-id]');
    if (!card) return;
    try {
      const url = new URL(link.href);
      if (url.origin !== location.origin || !/\/products\/[^/]+/.test(url.pathname)) return;
    } catch { return; }
    const results = card.closest('[data-leslis-predictive-results], [data-leslis-search-results]');
    if (!results) return;
    const source = results.hasAttribute('data-leslis-predictive-results') ? 'predictive' : 'results';
    if (source === 'predictive' && !predictiveVisible(results)) return;
    impression(results, source);
    record('product_clicked', {
      query: results.dataset.leslisQuery, source, resultCount: results.dataset.leslisResultCount,
      productId: card.dataset.leslisProductId, productTitle: card.dataset.leslisProductTitle, position: card.dataset.leslisPosition
    });
  }, true);

  function recordCurrentPage() {
    document.querySelectorAll('[data-leslis-search-results]').forEach((element) => impression(element, 'results'));
  }
  function consentChanged() {
    recordCurrentPage();
    document.querySelectorAll('predictive-search[open]').forEach(schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', recordCurrentPage, { once: true });
  else recordCurrentPage();
  document.addEventListener('leslis:search-results-rendered', recordCurrentPage);
  document.addEventListener('visitorConsentCollected', consentChanged);
  window.addEventListener('CookiebotOnAccept', consentChanged);
  window.addEventListener('CookiebotOnConsentReady', consentChanged);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') consentChanged(); });

  if (!isPreview() && !window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => { if (!error) consentChanged(); }); } catch {}
  }
  window.LeslisSearchEvents = Object.freeze({ status: () => ({ endpointConfigured: Boolean(endpoint()), preview: Boolean(isPreview()), consent: consentAllowed(), queuedEvents: sent }) });
})();
